import * as React from 'react';
import {
  message,
} from 'antd';

export function useAddToHomescreenPrompt() {
  const [prompt, setState] = React.useState(
    null,
  );

  const promptToInstall = () => {
    if (prompt) {
      return prompt.prompt();
    }
    return Promise.reject(
      message.warning(
        'Unable to install Application, please contact support or try again.',
      ),
    );
  };

  React.useEffect(() => {
    const ready = (e) => {
      e.preventDefault();
      setState(e);
    };

    window.addEventListener('beforeinstallprompt', ready);

    return () => {
      window.removeEventListener('beforeinstallprompt', ready);
    };
  }, []);

  return [prompt, promptToInstall];
}
